import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import initialState, {
  fulfilledHandler,
  loadingHandler,
  rejectedHandler,
} from "./initialState";
import api from "../api";

export const GetAllMenu = createAsyncThunk(
  "menu/GetAllMenu",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(`${api}master/menu/all?${data.url}`, {
        headers: {
          Authorization: data.token,
        },
      });
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const GetSingleMenu = createAsyncThunk(
  "menu/GetSingleMenu",
  async (data, thunkAPI) => {
    try {
      const response = await axios.get(
        `${api}master/menu/get_by_id/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const CreateMenu = createAsyncThunk(
  "menu/CreateMenu",
  async (data, thunkAPI) => {
    try {
      const response = await axios.post(
        `${api}master/menu`,
        {
          nama: data.nama,
          link_menu: data.link_menu,
          keterangan: data.keterangan,
          class_icon: data.class_icon,
          nama_menu_home: data.nama_menu_home,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const EditMenu = createAsyncThunk(
  "menu/EditMenu",
  async (data, thunkAPI) => {
    try {
      const response = await axios.put(
        `${api}master/menu/${data.id}`,
        {
          nama: data.nama,
          link_menu: data.link_menu,
          keterangan: data.keterangan,
          class_icon: data.class_icon,
          nama_menu_home: data.nama_menu_home,
        },
        {
          headers: {
            Authorization: data.token,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const DeleteMenu = createAsyncThunk(
  "menu/DeleteMenu",
  async (data, thunkAPI) => {
    let listData;
    try {
      const responseDelete = await axios.delete(
        `${api}master/menu/${data.id}`,
        {
          headers: {
            Authorization: data.token,
          },
        }
      );

      if (responseDelete.data.success) {
        listData = await axios.get(`${api}master/menu/all?${data.url}`, {
          headers: {
            Authorization: data.token,
          },
        });

        return {
          delete: responseDelete.data,
          meta: listData.data.meta,
          items: listData.data.items,
        };
      }
    } catch (error) {
      if (error.response) {
        const message = error.response.data;
        return thunkAPI.rejectWithValue(message);
      }
    }
  }
);

export const menuSlice = createSlice({
  name: "menu",
  initialState,
  reducers: {
    reset: (state) => initialState,
  },
  extraReducers: (builder) => {
    // get all menu
    builder.addCase(GetAllMenu.pending, loadingHandler);
    builder.addCase(GetAllMenu.fulfilled, fulfilledHandler);
    builder.addCase(GetAllMenu.rejected, rejectedHandler);
    // get Single menu
    builder.addCase(GetSingleMenu.pending, loadingHandler);
    builder.addCase(GetSingleMenu.fulfilled, fulfilledHandler);
    builder.addCase(GetSingleMenu.rejected, rejectedHandler);
    // create menu
    builder.addCase(CreateMenu.pending, loadingHandler);
    builder.addCase(CreateMenu.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isCreate: true });
    });
    builder.addCase(CreateMenu.rejected, rejectedHandler);
    // edit menu
    builder.addCase(EditMenu.pending, loadingHandler);
    builder.addCase(EditMenu.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isEdit: true });
    });
    builder.addCase(EditMenu.rejected, rejectedHandler);
    // delete menu
    builder.addCase(DeleteMenu.pending, loadingHandler);
    builder.addCase(DeleteMenu.fulfilled, (state, action) => {
      fulfilledHandler(state, action, { isError: true });
    });
    builder.addCase(DeleteMenu.rejected, rejectedHandler);
  },
});

export const { reset } = menuSlice.actions;
export default menuSlice.reducer;
